import { axiosInstance } from "../Axios/AxiosInstance";
import { getAuthHeaders } from "./pwa";

export const fetchNotifications = async (limit = 30) => {
  const res = await axiosInstance.get(`notifications?limit=${limit}`, getAuthHeaders());
  return res?.data;
};

export const markNotificationRead = async (id) => {
  const res = await axiosInstance.put(`notifications/${id}/read`, {}, getAuthHeaders());
  return res?.data;
};

export const markAllNotificationsRead = async () => {
  const res = await axiosInstance.put("notifications/read-all", {}, getAuthHeaders());
  return res?.data;
};

export const fetchPushStatus = async () => {
  const res = await axiosInstance.get("notifications/status", getAuthHeaders());
  return res?.data;
};

export const sendTestNotification = async () => {
  const res = await axiosInstance.post("notifications/test", {}, getAuthHeaders());
  return res?.data;
};
